import { createActionCardSource } from '@/features/action-cards/action-card-mention-source';
import { electronApis } from '@/features/electron-api';
import { createGroupSource } from '@/features/hivemind/mentions';
import {
  createAppSource,
  createEmojiExtension,
  createMentionExtensions,
  createSlashExtension,
  type MentionedApp,
} from '@/features/mention';
import { createPersonSource } from '@/features/people-wiki/mentions';
import { createSkillSource } from '@/features/plugins/skill-mention-source';
import { createTeamChatMemberSource } from '@/features/team-chats/team-chat-mention-source';
import { trackEvent } from '@/utils/analytics';

/** Open windows the user can @-mention. Empty off-macOS / when ContextKit is down. */
const listMentionableApps = async (): Promise<MentionedApp[]> => {
  const windows = await electronApis.context.getMentionableWindows();
  return windows
    .map((window) => ({
      pid: window.pid,
      windowId: window.windowId,
      name: window.name,
      iconUrl: window.iconURL ?? null,
      bundleId: window.bundleIdentifier ?? null,
      windowTitle: window.windowTitle,
    }))
    .sort((a, b) => {
      const appOrder = a.name.localeCompare(b.name);
      if (appOrder !== 0) return appOrder;
      return (a.windowTitle ?? '').localeCompare(b.windowTitle ?? '');
    });
};

export const mentionExtensions = createMentionExtensions({
  sources: [
    createTeamChatMemberSource(),
    createAppSource({
      listApps: listMentionableApps,
      onSelect: () => trackEvent('APP_MENTION_ADDED'),
    }),
    createActionCardSource(),
    createPersonSource(),
    createGroupSource(),
  ],
});

export const skillExtension = createSlashExtension({
  sources: [
    createSkillSource({ onSelect: () => trackEvent('SKILL_MENTION_ADDED') }),
  ],
});

export const emojiExtension = createEmojiExtension();
